import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(0),
      //   width: '28ch',
      },
    },
  }));

export default function InputComponent(props) {
    const classes = useStyles();
    const [IsConnectedWith, setContactPerson] = React.useState(props.IsConnectedWith);
    React.useEffect(()=>{
        setContactPerson(props.IsConnectedWith)
    })
    return (
        <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          variant="outlined"
          fullWidth
          label={<IntlMessages id="input.Calculator.Copy"/>}
          size="small"
          name="OffertID"
          select
          value={IsConnectedWith}
          SelectProps={{
            native: true,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={props.handleChange}
        >
            <option kay={0} value={0}><IntlMessages id="Prospectus"/> #19{props.AvtalId}</option>
          {props.currencies.map((option) => (
             <option key={option.id} value={option.id}>
             <IntlMessages id="Offer"/>-#{option.Offertnr}-{option.OrderType}
             </option>
          ))}
        </TextField>
      </div>
    </form>
    );
}